module.exports = __webpack_public_path__ + "img/infiniti-Worth.cdd2dde0.png";